import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";

const appearance = {
  variables: {
    colorPrimary: "#5b2a93",
    colorPrimaryForeground: "#ffffff",
    fontFamily: "'Bricolage Grotesque', sans-serif",
    borderRadius: "0.85rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/admin"
      signUpFallbackRedirectUrl="/admin"
      afterSignOutUrl="/"
      localization={{ signIn: { start: { title: "Sign in to OnDose", titleCombined: "Continue to OnDose", subtitle: "OnDose admin · email code", subtitleCombined: "OnDose admin · email code" }, emailCode: { subtitle: "to continue to OnDose" } }, signUp: { start: { title: "Create your OnDose account", titleCombined: "Continue to OnDose", subtitle: "OnDose admin", subtitleCombined: "OnDose admin" }, emailCode: { subtitle: "to continue to OnDose" } } }}
    >
      {children}
    </ClerkProvider>
  );
}
